import { api } from './cliente';
import type {
  PreferenciasNotificacao, SituacaoWhatsApp,
} from '../../shared/schemas/notificacoes';

export interface Aviso {
  id: string;
  tipo: string;
  titulo: string;
  texto: string;
  destino: string | null;
  lida_em: number | null;
  criado_em: number;
}

export const notificacoesQuery = {
  queryKey: ['notificacoes'] as const,
  queryFn: () => api.get<{ notificacoes: Aviso[]; nao_lidas: number }>('/notificacoes'),
  // A contagem do sino precisa envelhecer rápido, senão a pessoa marca como
  // lido numa aba e o número continua lá na outra.
  staleTime: 15_000,
};

export const marcarLida = (id: string) => api.post<void>(`/notificacoes/${id}/lida`, {});
export const marcarTodasLidas = () => api.post<void>('/notificacoes/lidas', {});

export const prefsNotificacaoQuery = {
  queryKey: ['prefs-notificacao'] as const,
  queryFn: () => api.get<{ preferencias: PreferenciasNotificacao }>('/eu/notificacoes'),
};

export const salvarPrefsNotificacao = (p: PreferenciasNotificacao) =>
  api.put<{ preferencias: PreferenciasNotificacao }>('/eu/notificacoes', p);

export const whatsappQuery = {
  queryKey: ['whatsapp-conta'] as const,
  queryFn: () => api.get<{ whatsapp: SituacaoWhatsApp }>('/eu/whatsapp'),
};

export const pedirCodigoWhatsApp = (telefone: string) =>
  api.post<{ enviado_para: string; expira_em: number }>('/eu/whatsapp/codigo', { telefone });
export const confirmarCodigoWhatsApp = (codigo: string) =>
  api.post<{ telefone: string; verificado: true }>('/eu/whatsapp/confirmar', { codigo });
export const salvarAvisosWhatsApp = (avisos: boolean) =>
  api.put<{ avisos: boolean }>('/eu/whatsapp', { avisos });
export const removerWhatsApp = () => api.del<void>('/eu/whatsapp');
